"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v1Upgrade = exports.v1Downgrade = void 0;
const v1Downgrade = (rule) => {
    const { ubCode, embUuid, trigger, displaySettings, published, id, event, version, parentVersion, meta, targets } = rule;
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        published,
        id,
        event,
        version,
        parentVersion,
        meta,
        targets,
    };
};
exports.v1Downgrade = v1Downgrade;
const v1Upgrade = (rule) => {
    const { ubCode, embUuid, trigger, displaySettings, published, id, event, version, parentVersion, meta, targets } = rule;
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        published,
        id,
        event,
        version,
        parentVersion,
        meta,
        targets,
        frequency: {
            name: 'everyVisit',
            parameters: [{ name: 'visitFrequency', value: '1' }],
        },
        schemaVersion: 1,
    };
};
exports.v1Upgrade = v1Upgrade;
//# sourceMappingURL=v01.js.map